type UsePasteOptions = {
  maxTextLength?: number
  getCurrentValue: () => string
  onPasteComplete: (newValue: string) => void
}

export function usePaste(options: UsePasteOptions) {
  const { maxTextLength: maxLength = Number.MAX_SAFE_INTEGER, getCurrentValue, onPasteComplete } = options

  function onTextPaste(event: ClipboardEvent, target: HTMLTextAreaElement): string | null {
    const clipboardText = event.clipboardData?.getData('text') ?? ''
    const currentText = getCurrentValue()
    const selectionStart = typeof target.selectionStart === 'number' ? target.selectionStart : currentText.length
    const selectionEnd = typeof target.selectionEnd === 'number' ? target.selectionEnd : selectionStart

    const nextText = currentText.slice(0, selectionStart) + clipboardText + currentText.slice(selectionEnd)

    if (nextText.length > maxLength) {
      event.preventDefault()

      const allowedLength = maxLength - (currentText.length - (selectionEnd - selectionStart))
      const truncatedPaste = allowedLength > 0 ? clipboardText.slice(0, allowedLength) : ''
      const newValue = currentText.slice(0, selectionStart) + truncatedPaste + currentText.slice(selectionEnd)

      nextTick(() => {
        const newCursorPos = selectionStart + truncatedPaste.length
        target.setSelectionRange(newCursorPos, newCursorPos)
      })

      return newValue
    }

    return null
  }

  function handlePaste(event: ClipboardEvent) {
    const target = event.target as HTMLTextAreaElement | null
    if (!target) return

    const hasText = event.clipboardData?.types.includes('text/plain')

    if (hasText) {
      const result = onTextPaste(event, target)
      if (result !== null) {
        onPasteComplete(result)
      }
    }
  }

  return {
    handlePaste,
  }
}
